export const WARNING_BORDER = 'zocks-border-color-warning-dark border-2'
